import { HabitSchedule, Timestamp } from '@griply/types';
import { isAfter, isBefore, startOfDay } from 'date-fns';

import { getScheduleEndDate } from './get-schedule-end-date';

export type GroupedSchedules = {
  current: HabitSchedule[];
  upcoming: HabitSchedule[];
  history: HabitSchedule[];
};

export const groupSchedulesByTime = (
  schedules: HabitSchedule[],
  today: Timestamp,
): GroupedSchedules => {
  const todayStart = startOfDay(today);

  const sortedSchedules = schedules
    .slice()
    .sort((a, b) => b.startDate.getTime() - a.startDate.getTime());

  const current: HabitSchedule[] = [];
  const upcoming: HabitSchedule[] = [];
  const history: HabitSchedule[] = [];

  sortedSchedules.forEach((schedule) => {
    if (isAfter(startOfDay(schedule.startDate), todayStart)) {
      upcoming.push(schedule);
      return;
    }

    const scheduleEnd = getScheduleEndDate(schedule);
    if (scheduleEnd && isBefore(scheduleEnd, todayStart)) {
      history.push(schedule);
      return;
    }

    current.push(schedule);
  });

  return { current, upcoming, history };
};
